module.exports = __webpack_public_path__ + "img/mapnew_small2.0d93dc95.png";